import { observer } from 'mobx-react';
import * as React from 'react';
import { SaveDialog } from 'ui-toolkit';
import { IRecordedMortgageRequired, IRecordedMortgage } from '../classes/RecordedMortgage';
import EditModalWindow from './EditModalWindow';
import RecordedMortgageBlock from './RecordedMortgageBlock';
import RecordedMortgageEdit from './RecordedMortgageEdit';

interface IRecordedMortgageDetailsProps {
  data: IRecordedMortgage;
  title: string;
  modalWindowTitle: string;
  userData: IRecordedMortgage;
  requiredFields: IRecordedMortgageRequired;
  onRecordedMortgageChange: (value: IRecordedMortgage, propName: string, error?: string | null) => void;
  errorRecordedMortgage: any;
  onUpdateDocument: () => void;
  onCancelClick: () => void;
  showSaveSpinner: boolean;
  showSaveSuccess: boolean;
  updateErrorText: string | null;
  recordedMortgageWasChanged: boolean;
}

interface IRecordedMortgageDetailsState {
  showEditRecordedMortgage: boolean;
  showSaveDialog: boolean;
}

class RecordedMortgageDetails extends React.Component<IRecordedMortgageDetailsProps, IRecordedMortgageDetailsState> {
  public readonly state: IRecordedMortgageDetailsState = {
    showEditRecordedMortgage: false,
    showSaveDialog: false,
  };

  public componentWillReceiveProps(newProps: IRecordedMortgageDetailsProps) {
    if (this.state.showEditRecordedMortgage && this.props.showSaveSuccess && !newProps.showSaveSuccess) {
      this.toggleEditWindow();
    }
    if (!this.props.updateErrorText && newProps.updateErrorText && this.state.showEditRecordedMortgage) {
      this.toggleSaveDialog();
    }
  }

  public render() {
    return (
      <>
        <RecordedMortgageBlock data={this.props.data} title={this.props.title} onEditClick={this.toggleEditWindow} />

        {this.state.showEditRecordedMortgage ? (
          <EditModalWindow
            title={this.props.modalWindowTitle}
            showSaveSpinner={this.props.showSaveSpinner}
            showSaveSuccess={this.props.showSaveSuccess}
            disableUpdateButton={this.props.recordedMortgageWasChanged}
            onUpdateDocument={this.onUpdateDocument}
            onClose={this.toggleEditWindow}
          >
            <RecordedMortgageEdit
              data={this.props.userData}
              requiredFields={this.props.requiredFields}
              errorRecordedMortgage={this.props.errorRecordedMortgage}
              onRecordedMortgageChange={this.props.onRecordedMortgageChange}
            />
          </EditModalWindow>
        ) : null}
        {this.state.showSaveDialog ? (
          <SaveDialog
            errorMessage={this.props.updateErrorText || ''}
            showSaveSpinner={this.props.showSaveSpinner}
            showSaveSuccess={this.props.showSaveSuccess}
            onYesClick={this.onUpdateDocument}
            onNoClick={this.toggleSaveDialog}
          />
        ) : null}
      </>
    );
  }

  private toggleEditWindow = () => {
    this.setState((state) => ({
      showEditRecordedMortgage: !state.showEditRecordedMortgage,
    }));
  };

  private toggleSaveDialog = () => {
    this.setState((state) => ({
      showSaveDialog: !state.showSaveDialog,
    }));
  };

  private onUpdateDocument = () => {
    if (this.props.recordedMortgageWasChanged) {
      this.props.onUpdateDocument();
    }
  };
}

export default observer(RecordedMortgageDetails);
